import { VATCODELIST_SEARCH, VATCODELIST_PAGE } from '../actions/vatcodelistactions';

const state = { search: '', page: 0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [VATCODELIST_SEARCH]: ({ commit }, search) => {
        commit(VATCODELIST_SEARCH, search);
    },
    [VATCODELIST_PAGE]: ({ commit }, page) => {
        commit(VATCODELIST_PAGE, page);
    }
};

const mutations = {
    [VATCODELIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [VATCODELIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};